export const REVIEW_COMMENTS = [
  {
    text: "Muita qualidade, sinto que identifiquei vários comportamentos que tenho nessa minha pequena trajetória, sinto que tenho que rever de tempos em tempos esse conteúdo para ir internalizando cada vez mais.",
    fullName: "Mario Rodrigues",
  },
  {
    text: "Curso de muita qualidade. Nem vi as 6 horas passando. É como os Asvid falou, só evolui quem faz e sempre busca aprimorar. A evolução é um caminho constante e sem fim, e nesse caminho, os erros vão ocorrendo, e o que não pode ocorrer é pararmos no tempo, não buscarmos aprender.",
    fullName: "Emerson Dias",
  },
  {
    text: "O curso é excelente. Essencial para quem pretende se tornar um investidor melhor, pois escancara o fato de que as maiores dificuldades para que isso se concretize reside em nós mesmos. Impossível assistir as aulas e não reconhecer que todos os vieses estão sempre presentes em nossas vidas, investindo ou não. O conteúdo que vocês criam e difundem é de valor inestimável para o investidor focado em aprender e evoluir ao longo do tempo. Parabéns e obrigado.",
    fullName: "Elton Mussi",
  },
  {
    text: "Excelente, como sempre. Asvid é um monstro!! Vlw, chefe!!!",
    fullName: "Diego Tavares",
  },
  {
    text: "Ótimo curso com um excelente professor!!! Um dos melhores investimentos que estou fazendo. Ao assistir esse curso específico vi o tanto de tempo que estou parado (aproximadamente 5 anos) sem evoluir",
    fullName: "Giulliano",
  },
  {
    text: "Excelente curso, muito pertinente cada ponto que você mencionou. Obrigado.",
    fullName: "Camargo Dias",
  },
  {
    text: "Ótimo curso. Informações úteis para quem está começando",
    fullName: "Ricardo Pipolo",
  },
  {
    text: "Curso muito importante e elucidativo. Parabéns, pessoal! Ainda tenho muito a aprender, mas já vi muita coisa que tava fazendo errado!!",
    fullName: "Rafael Almeida",
  },
  {
    text: "Excelente curso, um belo trabalho!",
    fullName: "Lucas Gomes",
  },
  {
    text: "Curso fundamental para todos os níveis. Esse aqui vale a volta em diferentes etapas da jornada!",
    fullName: "Luis Felipe Ramalho",
  },
  {
    text: "Grande Eduardo. Grande ASVID. Neste módulo, todas as aulas são excelentes, porque uma coisa leva a outra e, se você entende o conceito, o aprendizado inicial e começa a colocar em prática devagar, seguindo os ensinamentos do ASVID, caso eu erre, o erro é mínimo, porque eu já tenho uma base bem sólida, que vai sendo construída com o passar dos tempos. O Mindset é muito importante. A mentalidade forte é essencial seja na Vida Pessoal, Profissional ou nos Investimentos. Parabéns pelo Módulo e pelo Curso de modo geral.",
    fullName: "Daniel Fernando Cardoso",
  },
  {
    text: "Gostei muito do conteúdo do curso. Eu estou investindo desde junho do ano passado (2023), e tudo que foi dito no curso parecia que se referia a mim como investidor iniciante e empolgado, com todos esses vieses de viajante de primeira viagem. Tirei muito proveito teórico do curso e espero aplicá-lo na íntegra em meus investimentos futuros. Parabéns pelo profissionalismo com que o curso foi conduzido, bem como pelo conteúdo importante conteúdo abordado, que com certeza irá seguir de guia tanto para os novos investidores quanto para muitos investidores que já investem há algum tempo.",
    fullName: "Eduardo Borges",
  },
  {
    text: "Realmente quem está começando fica muito perdido, sem saber o que realmente importa, sem saber o que de fato faz diferença numa para uma tomada de decisão, vendo o curso parece que fica cada vez mais difícil rs, mas com certeza deixando essas informações irem amadurecendo e aprendendo como aplicá-las, vai fazer total diferença ao longo do tempo. Muito satisfeito com o conteúdo!",
    fullName: "Eliezer Santos",
  },
  {
    text: "Impressionante esse conteúdo, nada complicado, mas de uma profundidade ímpar para se lapidar um investidor. Valeu demais.",
    fullName: "Humberto Faria",
  },
  {
    text: "Foi ótimo, aprendi muito e vou colocar em prática. A sua didática é boa, parabéns 🎉",
    fullName: "Ivonete Silva",
  },
  {
    text: "Curso essencial para a formação do Investidor de longo prazo... Não se tem este tipo de conteúdo disponível de forma clara e objetiva, como foi apresentado aqui! Excelente trabalho!",
    fullName: "Gustavo Garrido",
  },
  {
    text: "Excelente curso! Arthur trouxe conhecimentos que são imprescindíveis para uma jornada de investimento de longo prazo. Só tenho agradecimentos!",
    fullName: "Fabiano Oliveira",
  },
  {
    text: "Conteúdo incrível... Só passando para agradecer!!!",
    fullName: "Jardenson Araujo",
  },
  {
    text: "Assistir a essas primeiras aulas foram de extrema importância para construir o alicerce de um bom investidor. Show!!",
    fullName: "Renan Lopes",
  },
  {
    text: "Essa primeira parte do curso seria um alicerce para o investidor apresentando noções básicas e eu estou muito satisfeito! Quando o Asvid começou a citar os tipos de vieses, eu comecei a me encaixar em cada um deles. Quando finalizar o último módulo, para reforçar, voltarei a rever esse módulo I. Agradecido!",
    fullName: "Luis Marcelo",
  },
  {
    text: "Conteúdo fenomenal. Valeu a pena o valor pago. Só esse mindset do Asvid explode a cabeça de qualquer investidor, iniciante ou profissional. Para mim (iniciante) serviu para mostrar o quanto eu fiz tudo errado até, cheio de vieses e emoções descontroladas. Sou novo e quero me permitir aprender com o tempo, sem pressa e na manha. Obrigado pela oportunidade Fundamentei!!!",
    fullName: "Alisson Santos",
  },
  {
    text: "Conteúdo rico. Comecei investir em ações ano passado, mas muita coisa foi com base em youtubers e dicas. Esse conteúdo tem me feito refletir bastante. Obrigado, galera.",
    fullName: "Allef Gomes",
  },
  {
    text: "Parabéns, esse conteúdo deveria ser obrigatório para quem quiser entrar nos investimentos tanto em Renda Fixa ou Renda Variável.",
    fullName: "Osama Wadud",
  },
  {
    text: "Estava lembrando das lives do Arthur, se não nos esforçarmos para entender e aplicar tudo que foi dito nesse módulo, nem adianta continuar investindo, faz todo sentido. Sempre acompanhando vocês, desejo muito sucesso!",
    fullName: "Diego Porto de Oliveira",
  },
  {
    text: "Parabéns pelo insight de ensinar sobre mentalidade e a relação com investimentos financeiros! Esse conteúdo é realmente diferenciado e agrega bastante.",
    fullName: "Felipe Emidio",
  },
  {
    text: "Essa base é essencial até para quem já investe há algum tempo, para relembrar! Nota 10",
    fullName: "Derik Silva",
  },
  {
    text: "Bom, essa primeira etapa do curso está sendo ótima para mim, acredito que vai contribuir e muito para minhas tomadas de decisão no futuro, parabéns pelo trabalho!",
    fullName: "Cleverson Ribeiro",
  },
  {
    text: "Amando os Curso Show de Bola. Seguimos!!!",
    fullName: "Wellington Oliveira",
  },
  {
    text: "Conteúdo rico ... Muita experiência e valor agregado ... Da para sentir ... Parabéns pelo curso ... Bem detalhado !",
    fullName: "Jardenson Araujo",
  },
  {
    text: "Espetacular. Só aqui no Fundamentei se encontra algo assim com qualidade, profundidade e simplicidade. Show demais. Parabéns.",
    fullName: "Humberto Faria",
  },
  {
    text: "Didática fantástica, venho aprendendo muito e moldando a forma de investir com os novos conhecimentos adquiridos. Este curso era o que eu procurava para melhorar minha forma de avaliar uma empresa, as aulas de rentabilidade, geração de caixa, demostrativos, foram espetaculares. Parabéns pelo trabalho.",
    fullName: "João Antônio Belicio",
  },
  {
    text: "Excelente curso! Aborda questões essenciais, em nível avançado, mas com toda a clareza e didática do Arthur!",
    fullName: "Fabiano Oliveira",
  },
  {
    text: "O conteúdo é ótimo, até aqui esse vídeo é uma preparação teórica para você começar a ter uma visão 100% Buy and Hold, tem assuntos e conteúdos que estou absorvendo melhor e outros não porque tem coisas que já tenho certa vivencia e outras coisas estou no início, mas dai começo a pesquisar para aprofundar mais no assunto e quando fica mais difícil já adiciono minhas dúvidas aqui que são sempre respondidas. O investimento que fiz para ser Black esta valendo cada real gasto em ter acesso todo o conteúdo de qualidade do site.",
    fullName: "Halisson Romano",
  },
  {
    text: "Ótimo conteúdo! Penso em como teria sido diferente se soubesse dessas informações no começo... Enfim, bola pra frente, vamos seguir evoluindo! Essas análises de carteira são boas para vermos que o processo não é perfeito, que investidores de perfis diferentes existem e como as experiências pessoais influenciam na tomada de decisão. Um toque humano em um curso técnico!",
    fullName: "Felipe Emidio",
  },
];

export const MORE_REVIEW_COMMENTS = [
  {
    text: "Excelente curso, verdadeiramente vocês estão de parabéns pela riqueza do conteúdo!",
    fullName: "Ederson Flavio Klitzke",
    course: "Análise de Ações Avançado",
  },
  {
    text: "Excelente curso e de conteúdo extenso e valioso que demanda bastante revisão para melhor aprimorar os nossos conhecimentos para ter mais segurança nas nossas aplicações financeiras. Parabéns ao FUNDAMENTEI.",
    fullName: "Eduardo Borges",
    course: "Fundos Imobiliários",
  },
  {
    text: "Excelente curso com um professor nota 10!!! Parabéns!!!",
    fullName: "Giulliano",
    course: "Como Investir em Ações",
  },
  {
    text: "Curso fantástico sobre os FIIs, pra mim foi um aprendizado partir basicamente do zero. Didática impecável e os esquemas ligando cada etapa durante as aulas ajudou muito. Parabéns pelo seu trabalho e sua dedicação.",
    fullName: "João Antônio",
    course: "Fundos Imobiliários",
  },
  {
    text: "Meu amigo, não consigo quantificar o quanto tenho aprendido no Black. Acompanho o fundamentei já a bons anos e sempre aprendo muito. Agora fazendo os cursos, percebo que o aprendizado é contínuo e vejo como tenho a oportunidade de aprender com esta equipe de profissionais. O curso é fantástico, valeu cada centavo investido, melhor, cada minuto que dedico as aulas e análises me acrescenta muito. Só posso dar os parabéns pela dedicação de toda a equipe do Fundamentei pelo trabalho impecável de vocês.",
    fullName: "João Antônio",
    course: "Análise de Ações na Prática",
  },
  {
    text: "Aula top!!! Comecei agora já estou virando fã do Arthur. Comecei a investir a + ou - 4 anos e é igual Arthur falou você começa e se conhecer com tempo. Black realmente é diferenciado Parabéns pelo curso Arthur gratidão.",
    fullName: "Wellington Oliveira",
    course: "Mindset do Investidor",
  },
  {
    text: "Estou gostando muito ds aulas, tem me ajudado muito.",
    fullName: "Edmilton Romão",
    course: "Análises de Carteiras",
  },
  {
    text: "Excelente, como sempre. Asvid é um monstro!! VIw, chefe!!!",
    fullName: "Diego",
    course: "Mindset do Investidor",
  },
  {
    text: "O curso é excelente. Essencial para quem pretende se tornar um investidor melhor, pois escancara o fato de que as maiores dificuldades para que isso se concretize reside em nós mesmos. Impossível assistir às aulas e não reconhecer que todos os vieses estão sempre presentes em nossas vidas, investindo ou não. O conteúdo que vocês criam e difundem é de valor inestimável para o investidor focado em aprender e evoluir ao longo do tempo. Parabéns e obrigado.",
    fullName: "Elton Mussi",
    course: "Mindset do Investidor",
  },
  {
    text: "Muito bom a maneira que foi exposto, o conteúdo deu para absorver bastante, parabéns a toda a equipe Fundamentei.",
    fullName: "Cleverson Ribeiro",
    course: "Análise de Ações Avançado",
  },
  {
    text: "Curso de muita qualidade. Nem vi as 6 horas passando. É como os Asvid falou, só evolui quem faz e sempre busca aprimorar. A evolução é um caminho constante e sem fim, e nesse caminho, os erros vão ocorrendo, e o que não pode ocorrer é pararmos no tempo, não buscarmos aprender.",
    fullName: "Emerson Dias",
    course: "Mindset do Investidor",
  },
  {
    text: "Muita qualidade, sinto que identifiquei vários comportamentos que tenho nessa minha pequena trajetória, sinto que tenho que rever de tempos em tempos esse conteúdo pra ir internalizando cada vez mais.",
    fullName: "Mario Rodrigues",
    course: "Mindset do Investidor",
  },
  {
    text: "Parabéns Eduardo. Para mim uma das aulas mais importantes!!!",
    fullName: "Wellington Oliveira",
    course: "Investimentos no Exterior",
  },
  {
    text: "Excelente o curso e a apresentação de fundamentos, obrigado pessoal! 🙏",
    fullName: "Ivan Linhares Martins",
    course: "Mindset do Investidor",
  },
  {
    text: "Achei todo o conteúdo muito bom. Realmente são pontos que deveriam ser avaliados no DIA 0Creio que eu não tenha errado muito neste momento, contudo, já estou reavaliando algumas decisões que tomei anteriormente e o apego a alguns ativos. Creio que irei aguardar as próximas aulas antes de alterar minha carteira... Parabéns a todos.",
    fullName: "Marco Antonio",
    course: "Mindset do Investidor",
  },
  {
    text: "Excelente conteúdo! Realmente é um tema de fundamental importância na nossa caminhada, em todas as áreas de nossas vidas.",
    fullName: "Thiago Monteiro",
    course: "Mindset do Investidor",
  },
  {
    text: "Gostei muito e tenho certeza de que será de grande valia para mim. Bastante didático e fácil de entendimento. Parabéns Asvid.",
    fullName: "Aldo Baraldi",
    course: "Mindset do Investidor",
  },
  {
    text: "Excelente, muito satisfeito! Concluindo este primeiro curso hoje MUITO satisfeito, eu que nunca investi em nada na vida aos meus 26 anos sinto que vou começar com o pé direito e a mentalidade correta. Parabéns e agradecimento ao Asvid que realmente estudou e se aprofundou nos temas tratados, achei bastante diferente do padrão (no melhor dos sentidos).",
    fullName: "Lucas Ribeiro",
    course: "Mindset do Investidor",
  },
  {
    text: "Excelente. Muita qualidade em todos os sentidos. Um curso fundamental para todos que querem aprender de forma correta a investir com foco no longo prazo. Não vi essa abordagem, da forma que o Asvid colocou nas aulas, bem como nas respostas aos comentários, feitas pelo Eduardo e Asvid em nenhum outro curso ou plataforma de ensino. O que vejo por aí é tudo muito superficial, muito nas “coxas”, a ideia é realmente vender, não ensinar. Essas mudanças de hábitos, atitudes e mentalidade, vão fazer toda a diferença como investidor. Parabéns. Vocês são ótimas referências.",
    fullName: "Jose Roberto Fernandes",
    course: "Mindset do Investidor",
  },
  {
    text: 'Curso excelente, com grande ênfase nos porquês e no fundamento do raciocínio, ao invés de um conjunto de heurísticas ou regras pra "se decorar" e seguir. A maneira como o Arthur explica dá toda segurança do mundo, porque uma vez que você entende o raciocínio por trás da construção da carteira você se sente muito melhor tomando as próprias decisões, e muito mais empoderado pra modificar alguma coisa quando é mais adequada à sua realidade. Sou uma pessoa no estágio inicial da montagem da carteira, então talvez dentro de uns 10 anos eu apareça pra dar um feedback adicional de como esse conhecimento maturou com o tempo. De todo modo, muito grato pelo curso e continue com o excelente trabalho! 😊',
    fullName: "Guilherme Tomishiyo",
    course: "Como Gerenciar sua Carteira",
  },
  {
    text: "Excelente conteúdo que me ajudou bastante a fazer as minhas escolhas de ações americanas. Vocês estão de parabéns!",
    fullName: "Eduardo Borges",
    course: "Análise de Ações na Prática",
  },
  {
    text: "Parabens pelo conteudo de todo o modulo. De forma clara, simples, porem muito profundidade. Aprendi muito com elas...",
    fullName: "Marco Antonio",
    course: "Análise de Ações Avançado",
  },
  {
    text: "Excelentes exemplos, principalmente para quem está começando. No começo a gente costuma ficar meio perdido, no escuro e essas aulas com certeza clareiam o caminho.",
    fullName: "João Neto",
    course: "Como Investir em Ações",
  },
  {
    text: "Excelente curso com conteúdo completo e diverso. Parabéns pelo curso. Aprendi bastante e acho que foi o dinheiro mais bem empregado até o momento em relação a cursos de ensinamento sobre aplicações financeiras, especialmente em relação à bolsa americana.",
    fullName: "Eduardo Borges",
    course: "Investimentos no Exterior",
  },
  {
    text: "Muito bom, consegui reforçar alguns conhecimentos que não estavam bem assimilados e aprendi ainda mais. Parabens.",
    fullName: "Aldo Baraldi",
    course: "Como Investir em Ações",
  },
  {
    text: "Curso é sem comentários. Melhor disparado de tudo que há diaponível no mercado. Como esse curso muda sobremaneira a forma de enxergarmos as oportunidades no exterior, além de nos dar embasamento, confiança e estímulo para se investir fora do Brasil. Parabéns a toda a equipe do Fundamentei, vcs fazem a diferença na vida de muitos investidores por esse país afora.",
    fullName: "Humberto Faria",
    course: "Investimentos no Exterior",
  },
  {
    text: "Muito objetivo e esclarecedor, gostaria de ter tido acesso antes, mas .... gostei muito do item 1.5, parabéns pelo conteúdo.",
    fullName: "Ricardo Penna",
    course: "Como Investir em Ações",
  },
  {
    text: 'Excelente conteúdo, se tivesse esse acesso há 4 anos não tinha cometido tanta sardinhagem, mas o ponto positivo é que sempre tive o objetivo de ganhos a longo prazo, mas no início sem saber, os dividendos se tornam muito atrativos e a maneira deles venderem é muito aliciadora. Aos poucos estou adaptando minha carteira com o conceito de "evolução" das empresas.',
    fullName: "Ricardo Penna",
    course: "Análise de Ações Avançado",
  },
  {
    text: "Aula excelente, estava com bastante duvida de como montar minha carteira de REITs e após essa explicação já estou bem mais confiante para escolher.",
    fullName: "Vinicius Barbosa",
    course: "Investimentos no Exterior",
  },
  {
    text: "Parabéns Asvid pela Aula!! Somente os seus dois comentários iniciais sobre REITs x FIIs já valeram pela aula toda e muito mais.",
    fullName: "Odair Valentini",
    course: "Análise de Ações na Prática",
  },
  {
    text: "Muito pertinente os temas abordados! Parabéns pelo planejamento.",
    fullName: "Danilo Freitas",
    course: "Mindset do Investidor",
  },
  {
    text: "Foi muito importante ter visto toda essa estrutura conceitual, me proporcionou a oportunidade de realizar correções no que venho executando no dia a dia.",
    fullName: "Gustavo Melotto",
    course: "Como Investir em Ações",
  },
  {
    text: "Uma das melhores aulas do curso! Sempre tive dificuldade de achar o problema de uma empresa que era boa e ficou ruim. Essa aula deu um norte legal. E realmente o mercado americano não é para amadores, quem segue diquinha de internet pode quebrar a cara bonito.",
    fullName: "Diego Silva",
    course: "Análise de Ações na Prática",
  },
  {
    text: "Aula muito top! Parabéns Arthur. Fiquei surpreso ao ver que o curso tem um módulo dedicado ao psicológico do futuro investidor. Acredito que quase nenhum curso de mercado financeiro oferece algo do tipo. Parabéns para a equipe! Anotei tudo que o Arthur ensinou durante as aulas e pretendo revisar frequentemente. Acredito que vocês disseram tudo que é essencial antes de começar a aprender a investir. Obrigado!",
    fullName: "Felipe Gabriel Ferraz",
    course: "Mindset do Investidor",
  },
  {
    text: "Gostei muito dessa aula e até o momento do curso como um todo. Já estudei um bocado o assunto e acho muito interessante a progressão e o jeito que vc coloca as coisas. Parabéns e abs!!",
    fullName: "João Marcos",
    course: "Valuation para Buy&Hold",
  },
  {
    text: 'Esta primeira etapa do curso foi muito importante pra mim. Eu "namorei" o mercado de renda variável durante muitos anos, mas nunca tive a condição/disciplina de fazer aportes constantes. Me identifiquei com muitos vieses apontados pelo Asvid e fiquei satisfeito quando ele mencionou "a pessoa que demorou 10 anos para entrar e agora quer entrar com pressa". É justamente o meu caso e eu prometo que não vou me apressar heheheh. A partir de agora é Bottom Up, estudo e aporte constante! Um Abraço ao Eduardo e ao Asvid!',
    fullName: "Thiago Scalzo",
    course: "Mindset do Investidor",
  },
  {
    text: "A verdade é que esse tipo de conhecimento é escasso e provavelmente não tem em nenhum outro lugar do mundo! Uma plataforma como essa então nem se fala. Depois de rodar os cantos do mercado financeiro fazendo todas as balbúrdias, futuros, opções, alavancagem e me machucando muito, além do que podia. Paguei e me sinto na obrigação de agradecer a todos os colaboradores do Fundamentei e em especial ao Arthur e ao Eduardo, espero que o valor da carteira de vcs fique irrisório perto do valor disso aqui. Aos que estão começando, espero que fiquem por aqui e nunca saiam. Um agradecimento de quem foi resgatado por vcs, abraços e muito obrigado.",
    fullName: "Tomas Gabriel",
    course: "Análise de Ações Avançado",
  },
  {
    text: "Estudar e investir assim fica fácil. Obrigado Eduardo.",
    fullName: "Rodrigo Lemos",
    course: "Lives | Eduardo Cavalcanti",
  },
  {
    text: "Ótimo curso, de fácil entendimento e de muito conteúdo.",
    fullName: "Ederson Flavio Klitzke",
    course: "Como Investir em Ações",
  },
  {
    text: "Esse insight “renda variável não é renda” e “dividendos não é dinheiro grátis“ é muito poderoso e virou minha chave como investidor. Percebo que o “pingado recorrente” (rendimentos de FIIs, dividendos de ações, etc) exerce um forte fascínio no investidor, como uma descarga de dopamina que as vezes embaralha a verdadeira natureza do rendimento/dividendo: distribuição de caixa do FII/empresa. Superar essa descarga recorrente de dopamina é um grande desafio para o investidor amadurecer, e passar a focar no que realmente importa: qualidade do negócio, capacidade de geração de resultado operacional, competência da gestão, etc.",
    fullName: "Rodrigo Spirandelli",
    course: "Mindset do Investidor",
  },
  {
    text: "Muito boa a progressão das informações bem didático, realmente um diferencial de vocês, não existe no mercado um serviço igual e isento, mais uma vez parabéns.",
    fullName: "Ricardo Penna",
    course: "Valuation para Buy&Hold",
  },
  {
    text: "Esse primeiro módulo do Black é realmente espetacular, irei ver e rever várias vezes! Parabéns pelo curso até aqui pessoal, excelente! Muito obrigado!",
    fullName: "Marcelo Padilha",
    course: "Mindset do Investidor",
  },
  {
    text: 'Aula top demais, a cada aula a mente "explode" com algumas sacadas e entendimento que vou adquirindo.',
    fullName: "Marcelo Padilha",
    course: "Demonstrativos Financeiros",
  },
  {
    text: "Tive alguns insights e percepções bem interessantes. Aprendizado constante. Sensacional!!!",
    fullName: "Daniel Fernando Cardoso",
    course: "Análise de Ações na Prática",
  },
];
